"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkVoteInputSchema = exports.RowEvidenceLocatorSchema = exports.EvidenceLinkedRowSchema = exports.RowEvidenceQuerySchema = exports.EvidenceRowSelectionSchema = exports.EvidenceRowKeySelectionSchema = exports.EvidenceLineageSelectionSchema = exports.EVIDENCE_SELECTION_MAX_ROWS = exports.TagVoteInputSchema = exports.EVIDENCE_VOTE_NOTE_MAX_LENGTH = exports.EvidencePreviewSchema = exports.EvidencePreviewUnavailableReasonSchema = exports.EvidencePreviewUnavailableReason = exports.TopicEvidenceLocatorSchema = void 0;
exports.isEvidenceLineageSelection = isEvidenceLineageSelection;
const z = require("zod");
const slice_key_1 = require("../Consensus/slice-key");
const evidence_confidence_1 = require("./evidence-confidence");
const evidence_locator_types_1 = require("./evidence-locator.types");
const evidence_topic_1 = require("./evidence-topic");
const evidence_vote_types_1 = require("./evidence-vote.types");
exports.TopicEvidenceLocatorSchema = z.object({
    locator: evidence_locator_types_1.EvidenceLocatorFactsSchema,
    elementIndex: z.number().int().min(0).nullable(),
    myVote: evidence_vote_types_1.EvidenceVotePolaritySchema.nullable(),
    confidence: evidence_confidence_1.EvidenceConfidenceSchema,
});
var EvidencePreviewUnavailableReason;
(function (EvidencePreviewUnavailableReason) {
    EvidencePreviewUnavailableReason["OcrVersionMismatch"] = "ocr_version_mismatch";
    EvidencePreviewUnavailableReason["NotRenderable"] = "not_renderable";
})(EvidencePreviewUnavailableReason || (exports.EvidencePreviewUnavailableReason = EvidencePreviewUnavailableReason = {}));
exports.EvidencePreviewUnavailableReasonSchema = z.nativeEnum(EvidencePreviewUnavailableReason);
exports.EvidencePreviewSchema = z.object({
    base64Image: z.string().nullable(),
    unavailableReason: exports.EvidencePreviewUnavailableReasonSchema.nullable(),
});
exports.EVIDENCE_VOTE_NOTE_MAX_LENGTH = 2000;
const EvidenceVoteNoteSchema = z
    .string()
    .trim()
    .min(1, { message: 'A note must not be blank.' })
    .max(exports.EVIDENCE_VOTE_NOTE_MAX_LENGTH, {
    message: `A note must be ${exports.EVIDENCE_VOTE_NOTE_MAX_LENGTH} characters or fewer.`,
});
exports.TagVoteInputSchema = z.object({
    fileId: z.string().min(1),
    locatorAddress: z.string().min(1),
    topic: evidence_topic_1.EvidenceTopicSchema,
    polarity: evidence_vote_types_1.EvidenceVotePolaritySchema,
    note: EvidenceVoteNoteSchema.optional(),
});
exports.EVIDENCE_SELECTION_MAX_ROWS = 16;
exports.EvidenceLineageSelectionSchema = z
    .object({
    sliceKey: slice_key_1.SliceKeySchema,
    lineageId: z.string().min(1),
})
    .strict();
exports.EvidenceRowKeySelectionSchema = z
    .object({
    sliceKey: slice_key_1.SliceKeySchema,
    sliceVersion: z.number().int().min(1),
    rowKey: z.string(),
})
    .strict();
exports.EvidenceRowSelectionSchema = z.union([
    exports.EvidenceLineageSelectionSchema,
    exports.EvidenceRowKeySelectionSchema,
]);
function isEvidenceLineageSelection(selection) {
    return 'lineageId' in selection;
}
exports.RowEvidenceQuerySchema = z.object({
    packageId: z.string().min(1),
    selections: z.array(exports.EvidenceRowSelectionSchema).min(1).max(exports.EVIDENCE_SELECTION_MAX_ROWS),
});
exports.EvidenceLinkedRowSchema = z.object({
    sliceKey: slice_key_1.SliceKeySchema,
    rowKey: z.string(),
    lineageId: z.string().nullable(),
});
exports.RowEvidenceLocatorSchema = z.object({
    locator: evidence_locator_types_1.EvidenceLocatorFactsSchema,
    container: evidence_locator_types_1.EvidenceLocatorFactsSchema.nullable(),
    linkedRows: z.array(exports.EvidenceLinkedRowSchema),
    myVote: evidence_vote_types_1.EvidenceVotePolaritySchema.nullable(),
    confidence: evidence_confidence_1.EvidenceConfidenceSchema,
});
exports.LinkVoteInputSchema = z.object({
    packageId: z.string().min(1),
    locatorAddress: z.string().min(1),
    selections: z.array(exports.EvidenceRowSelectionSchema).min(1).max(exports.EVIDENCE_SELECTION_MAX_ROWS),
    polarity: evidence_vote_types_1.EvidenceVotePolaritySchema,
    note: EvidenceVoteNoteSchema.optional(),
});
//# sourceMappingURL=evidence-contracts.types.js.map